var cov_7debywdpp = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Divider/styles/index.ts",
      hash = "98bab1df86e0d8a016a5c4f6cb724bfeccb3c611",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Divider/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 28
        },
        end: {
          line: 5,
          column: 62
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var dividerLess = {};
import genaration from '../../utils/classname';
export var dividerClass = (cov_7debywdpp.s[0]++, genaration(dividerLess, 'divider'));